import mva2019 from './mva2019';
import mva2020 from './mva2020';
import mva2021 from './mva2021';

const mvaData = {
  mva2019,
  mva2020,
  mva2021,
};

export default mvaData;
